import { useState } from 'react';

interface Faq {
  question: string;
  answer: string;
}

interface FaqSectionProps {
  faqs: Faq[];
}

export default function FaqSection({ faqs = [] }: FaqSectionProps) {
  const [open, setOpen] = useState<number | null>(0);

  if (faqs.length === 0) {
    return null;
  }

  return (
    <div className="pt-8">
      <h2 className="text-lg font-bold text-[#121B35] mb-4">
        자주 묻는 질문
      </h2>

      <div className="space-y-2">
        {faqs.map((faq, index) => (
          <div
            key={`${faq.question}-${index}`}
            className="bg-white rounded-2xl border border-[#E8E2DA] overflow-hidden"
          >
            <button
              onClick={() => setOpen(open === index ? null : index)}
              className="w-full flex items-center justify-between px-4 py-3.5 text-left active:bg-[#FAF8F4] transition-colors"
            >
              <span className="text-[13px] font-medium text-[#121B35] pr-2">
                {faq.question}
              </span>
              <i
                className={`ri-arrow-down-s-line text-[#536079] transition-transform shrink-0 ${
                  open === index ? 'rotate-180' : ''
                }`}
              />
            </button>

            {open === index && (
              <div className="px-4 pb-3.5">
                <p className="text-[12px] text-[#536079] leading-[1.8]">
                  {faq.answer}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}